import styled from 'styled-components';

import DashboardSessionSecondRow from './DashboardSessionSecondRow';
import DashboardSessionSelect from './DashboardSessionSelect';
import DashboardSessionTimeRow from './DashboardSessionTimeRow';

const ClassViewContainer = styled.div`
    margin: 12px;
    display: flex;
    flex-direction: column;
`;

const DashboardClassView: React.FC = () => (
    <ClassViewContainer>
        <DashboardSessionSelect/>
        <DashboardSessionTimeRow/>
        <DashboardSessionSecondRow/>
    </ClassViewContainer>
);

export default DashboardClassView;
